import { type ReactNode, useEffect } from "react"
import { CloseIcon } from "./icons.tsx"

/** A centred dialog over the app; Escape or the backdrop closes it. */
export function Modal({ children, onClose, title, wide = false }: {
  readonly title: string
  readonly onClose: () => void
  readonly children: ReactNode
  readonly wide?: boolean
}) {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => event.key === "Escape" && onClose()
    window.addEventListener("keydown", onKey)
    return () => window.removeEventListener("keydown", onKey)
  }, [onClose])

  return (
    <div className="modal-backdrop" onPointerDown={(event) => event.target === event.currentTarget && onClose()}>
      <div className={wide ? "modal modal-wide" : "modal"} role="dialog" aria-modal="true" aria-label={title}>
        <header className="modal-header">
          <h2>{title}</h2>
          <button type="button" className="icon-button" aria-label="Close" onClick={onClose}>
            <CloseIcon />
          </button>
        </header>
        {children}
      </div>
    </div>
  )
}
